// extracted by mini-css-extract-plugin
export default {"msg":"Notify_msg__wm6MW"};